/* global Vue, VeeValidate, VueI18n */

import { Notifications, setSuccessAndStopLoading, setErrorAndStopLoading, startLoading } from './components/Notifications'
import CountriesDropdown from './components/CountriesDropdown'
import { messagesSpecific } from '../i18n/translations'
import { CreateI18n } from '../i18n/create-i18n'
import '../validation-rules'

const i18n = CreateI18n(messagesSpecific)

const GroupsApp = Vue.createApp({
  name: 'GroupsApp',
  components: { CountriesDropdown, Notifications },
  template: '#groups-app-template',

  setup () {
    const { t } = VueI18n.useI18n()
    const form = Vue.reactive({})
    const formErrors = Vue.reactive({})
    const formElement = Vue.ref(null)
    const validationSchema = {
      firstName: 'required|min:3',
      lastName: 'required|min:3',
      email: 'required|email',
      subject: 'required|min:3',
      message: 'required',
    }

    const { handleSubmit, handleReset, errors, isSubmitting } = VeeValidate.useForm({ validationSchema })

    const fieldRefs = Vue.reactive({})
    Object.keys(validationSchema).forEach((field) => {
      const fieldObj = VeeValidate.useField(field, undefined, {
        validateOnValueUpdate: false,
      })

      form[field] = fieldObj.value
      formErrors[field] = fieldObj.errorMessage
      fieldRefs[field] = fieldObj
    })

    function validateField (field) {
      fieldRefs[field].validate()
    }

    Vue.watch(isSubmitting, () => {
      if (Object.keys(errors).length > 0 && formElement.value) {
        const highlight = Array.from(formElement.value.querySelectorAll('.field-error')).filter(er => er.innerHTML)[0] || null
        if (highlight) { highlight.parentNode.scrollIntoView({ behavior: 'smooth' }) }
      }
    })

    const sendForm = handleSubmit(async () => {
      startLoading('handleSubmit')
      try {
        const response = await fetch('/', {
          method: 'POST',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
          body: `${new URLSearchParams(form).toString()}&form-name=Groups`,
        })
        if (!response.ok) {
          throw new Error(response.statusText)
        }
        handleReset()
        setSuccessAndStopLoading({ details: t('formSubmitSuccess') })
      } catch (err) {
        setErrorAndStopLoading(err)
      }
    })

    return {
      form,
      formElement,
      formErrors,
      sendForm,
      validateField,
    }
  },
})

const appElement = document.getElementById('groups-app')

if (appElement) {
  GroupsApp.use(i18n)
  GroupsApp.mount(appElement)
}
